import { render, staticRenderFns } from "./AddCategoria.vue?vue&type=template&id=59ef5b20&"
import script from "./AddCategoria.vue?vue&type=script&lang=js&"
export * from "./AddCategoria.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports